module.exports = __webpack_public_path__ + "static/flatart_ai_studio_header_02-f087793603e5e220d8d9ffdf1d4d4db5.webp";